import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function EmailReportRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.EmailReport', {
		url: '/emails/:id',
		controllerAs: 'vm',
		controller: EmailReportCtrl,
		templateUrl: '/ng/hub/Email/Report/EmailReportCtrl.html?' + window.BUILD,
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Email/Report/EmailReportCtrl.css'),
			$title: () => 'Email Report',
			email: ApiResourcify.endpoint('/emails/:id', {
				withResponse: resp => {
					if (resp.status == 404) {
						window.location.href = '#/emails';
					}
					return resp.data;
				},
			}),
			stats: ApiResourcify.endpoint('/emails/:id/stats?summary_only=true'),
		},
	});
}

export class EmailReportCtrl {
	constructor($filter, Api, Cfg, email, modal, stats) {
		'ngInject';
		this.$filter = $filter;
		this.modal = modal;
		this.Api = Api;
		this.email = email;
		this.stats = stats;
		// adding this item to breadcrumbs
		this.menuItem = [
			{
				text: 'Stats',
				title: 'Statistics for a delivered email',
				href: '/hub#/emails/' + this.email.id,
			},
		];
		this.selectOptions = [
			{
				value: 'all',
				label: 'All',
			},
			{
				value: 'opened',
				label: 'Opened',
			},
			{
				value: 'unopened',
				label: 'Unopened',
			},
			{
				value: 'bounced',
				label: 'Bounced',
			},
			{
				value: 'autoresponded',
				label: 'Auto-responded',
			},
		];
		this.hideLikesAndComments = Cfg.read('Features.hide_likes_and_comments') !== '0';
		this.transformRecipients = this.transformRecipients.bind(this);
		this.recipientDetails = this.recipientDetails.bind(this);
		this.isLoading = false;
		this.dataTableLimit = 10;
		this.getSender(this.email.user_id);
	}

	getSender(senderId) {
		this.Api.get(`/users/${senderId}`).then(resp => {
			this.sender = resp;
		});
	}

	/**
	 * Format the open date (or replace with correct status -- bounced or unopened) and compute full name
	 * @param response
	 * @returns {Object}
	 */
	transformRecipients(response) {
		let dateFormat = this.$filter('shDate');
		response.data = response.data.map(recipient => {
			if (recipient.bounced) {
				recipient.first_action_date = '(bounced)';
			} else if (recipient.first_action_date) {
				recipient.first_action_date = dateFormat(recipient.first_action_date, 'long');
			} else if (recipient.auto_response_date) {
				recipient.first_action_date = '(auto-responded)';
			} else {
				recipient.first_action_date = '(unopened)';
			}
			recipient.name = `${recipient.fname} ${recipient.lname}`;

			return recipient;
		});
		return response;
	}

	/**
	 * Get all stats for this email again and update `this.stats`.
	 */
	refreshStats() {
		// add class that fades out
		this.isLoading = true;
		this.Api.get(`/emails/${this.email.id}/stats`).then(resp => {
			// remove class
			this.isLoading = false;
			this.stats = resp;
		});
	}

	recipientDetails(recipient) {
		this.modal.state('hub.loggedin.EmailRecipients', {
			heading: 'Recipient Details',
			params: { id: this.email.id, user_id: recipient.user_id },
			width: '840px',
		});
	}
}
